import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=ded4e39e&"
import script from "./AspectRatio.vue?vue&type=script&lang=js&"
export * from "./AspectRatio.vue?vue&type=script&lang=js&"
import style0 from "./AspectRatio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports